import { render, staticRenderFns } from "./InsuranceCompanyList.vue?vue&type=template&id=9a6fcaa6&scoped=true&"
import script from "./InsuranceCompanyList.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyList.vue?vue&type=style&index=0&id=9a6fcaa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6fcaa6",
  null
  
)

export default component.exports